import { render, staticRenderFns } from "./ApplicantTab.vue?vue&type=template&id=13292b70&"
import script from "./ApplicantTab.vue?vue&type=script&lang=js&"
export * from "./ApplicantTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports